import { render, staticRenderFns } from "./WidgetMap.vue?vue&type=template&id=0851b21e"
import script from "./WidgetMap.vue?vue&type=script&lang=js"
export * from "./WidgetMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports